import React, { memo } from 'react';
import type { FunctionComponent } from 'react';
import { useCountDownTicker } from './useCountDownTicker';
import { timeFormatter } from '@utils';

export interface CountDownTickerInterface {
	time: number;
	action: () => void;
}

export const CountDownTicker: FunctionComponent<CountDownTickerInterface> = memo(({ time, action }) => {
	const { active, currentTime } = useCountDownTicker({ time, action });

	if (!active) return null;
	return <div>{timeFormatter(currentTime)}</div>;
});
